import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Box, Typography, Divider, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useStore } from '@mcn-platform/models';
// import formatCurrencyByLocale from '../common/formatCurrencyByLocale';
import TableList from './TableList';
const titleField = {
    name: 'name',
    label: 'Name',
};
const membershipSecondaryFields = [
    { name: 'term', label: 'Term' },
    { name: 'nextPaymentAt', label: 'Next Billing Date' },
    { name: 'status', label: 'Status' },
];
const purchasesSecondaryFields = [
    { name: 'status', label: 'Status' },
];
const BillingPayment = () => {
    const store = useStore();
    const members = store.currentMembers;
    const [memberships, setMemberships] = useState([]);
    const [purchases, setPurchases] = useState([]);
    useEffect(() => {
        const m = members.reduce((memberList, member) => {
            if (member.membership?.type === 'membership') {
                memberList.push({
                    id: member.id,
                    name: member.name,
                    term: member.membership?.recurringTerm,
                    nextPaymentAt: member.nextPaymentAt,
                    status: member.status,
                });
            }
            return memberList;
        }, []);
        setMemberships(m);
        const p = members.reduce((list, member) => {
            if (member.membership?.type === 'course' || member.membership?.type === 'program') {
                list.push({
                    id: member.id,
                    name: member.name,
                    status: member.status,
                });
            }
            return list;
        }, []);
        setPurchases(p);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [members, ...members.map((member) => member.membership?.syncState)]);
    return (_jsxs(Box, { sx: { width: '100%', marginBottom: 20 }, children: [memberships?.length === 0 && purchases?.length === 0 && (_jsx(Typography, { variant: "h5", fontWeight: 700, sx: { mt: 5, pb: 1 }, children: "You have no active memberships or purchases." })), memberships?.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h5", fontWeight: 700, sx: { mt: 5, pb: 1 }, children: "Memberships" }), _jsx(Divider, {}), _jsx(TableList, { items: memberships, titleField: titleField, secondaryFields: membershipSecondaryFields, showSelect: false, handleSelectAll: () => true, handleSelectOne: () => true, selectedIDs: [], actions: [] })] })), purchases?.length > 0 && (_jsxs(_Fragment, { children: [_jsx(Typography, { variant: "h5", fontWeight: 700, sx: { mt: 5, pb: 1 }, children: "Purchases" }), _jsx(Divider, {}), _jsx(TableList, { items: purchases, titleField: titleField, secondaryFields: purchasesSecondaryFields, showSelect: false, handleSelectAll: () => true, handleSelectOne: () => true, selectedIDs: [], actions: [] })] }))] }));
};
export default observer(BillingPayment);
//# sourceMappingURL=BillingPayment.js.map